import { createContext, useContext, useEffect, useState } from 'react'

const LocaleContext = createContext({ locale: 'en', t: (k) => k, ready: false })

export function LocaleProvider({ locale, children }) {
  const [catalog, setCatalog] = useState({})
  const [ready, setReady] = useState(false)

  useEffect(() => {
    setReady(false)
    import(`../locales/${locale}.json`)
      .then(m => { setCatalog(m.default ?? m); setReady(true) })
      .catch(() => { setCatalog({}); setReady(true) })
  }, [locale])

  function t(key, params = {}) {
    const val = key.split('.').reduce((o, k) => o?.[k], catalog)
    if (val == null) {
      if (import.meta.env?.DEV) {
        console.warn(`[i18n] Missing translation key: "${key}" (locale: ${locale})`)
      }
      return key
    }
    return Object.entries(params).reduce(
      (s, [k, v]) => s.replaceAll(`{{${k}}}`, v),
      val
    )
  }

  return (
    <LocaleContext.Provider value={{ locale, t, ready }}>
      {children}
    </LocaleContext.Provider>
  )
}

export function useLocale() {
  return useContext(LocaleContext)
}
